import React from 'react'
import { Menu } from 'antd'
import { styles } from './index.sass'
import { PagePermissions } from '../../../utils/authManagement'
import { useSelector } from 'react-redux'
import { includes } from 'lodash'

const menuList = [
  {
    path: '/common-tools/recommended',
    key: 'recommended',
    label: 'Resources',
    perm: PagePermissions.RESOURCES
  },
  {
    path: '/common-tools/challenge',
    key: 'challenge',
    label: 'Challenge',
    perm: PagePermissions.CHALLENGES
  },
  {
    path: '/common-tools/email-report',
    key: 'email-report',
    label: 'Summary Email Report',
    perm: PagePermissions.WEEKLY_INSIGHTS
  },
  {
    path: '/common-tools/email-template',
    key: 'email-template',
    label: 'Summary Email Template',
    perm: PagePermissions.WEEKLY_INSIGHTS
  },
  {
    path: '/common-tools/data-aggregation',
    key: 'data-aggregation',
    label: 'Data Aggregation'
  },
  {
    path: '/common-tools/timeline-report',
    key: 'timeline-report',
    label: 'Timeline Report'
  },
  {
    path: '/common-tools/hsd-weighting',
    key: 'hsd-weighting',
    label: 'HSD Weighting',
    perm: PagePermissions.HSD
  },
  {
    path: '/common-tools/event-registration',
    key: 'event-registration',
    label: 'Event Registration'
  },
  {
    path: '/common-tools/partnership-registration',
    key: 'partnership-registration',
    label: 'Partnership Registration'
  },
  {
    path: '/common-tools/appointments',
    key: 'appointments',
    label: 'Appointments'
  }
]

export default function SlideMenu(props) {
  const { permissions } = useSelector((state) => state.account)

  const handleClick = (e) => {
    const menu = menuList.find((item) => item.key === e.key)
    props.history.push(menu.path)
  }

  const {
    location: { pathname }
  } = props
  const key = pathname.split('/')[2]

  return (
    <div className={styles}>
      <Menu
        onClick={handleClick}
        selectedKeys={[key]}
        mode="inline"
        items={menuList.filter(
          (item) => !item.perm || includes(Object.keys(permissions), item.perm)
        )}
      />
    </div>
  )
}
